<div *ngIf="mode !='mini' ">

  
  <div class="flex flex-horiz-space-bw">
    <h4><span class="col-red">* </span>Enter your Notes</h4>
    <a nz-dropdown [nzDropdownMenu]="cannedReplies" class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
    <nz-dropdown-menu #cannedReplies="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        <li nz-menu-item (click)="noteCannedReply('Please have a look at the ...')">Please have a look at the ...</li>
        <li nz-menu-item (click)="noteCannedReply('Requesting additional investigation ...')">Requesting additional
          investigation ...</li>
        <li nz-menu-item (click)="noteCannedReply('Required Documents are not in place ...')">Required Documents are not
          in place ...</li>
      </ul>
    </nz-dropdown-menu>
  </div>

  <textarea 
    rows="2" 
    maxlength="2000" 
    nz-input 
    [(ngModel)]="noteDO.description" 
    [ngClass]="{'ng-invalid': showValidationError && !(noteDO.description?.trim())}">
  </textarea>

  <p style="font-size: xx-small;">{{ noteDO.description?.length || 0 }}/2000 Characters</p>

  <div *ngIf="showValidationError && !(noteDO.description?.trim())" class="text-danger" style="color: red;">
    Note is required.
  </div>

  <h4 class="d-b m-t-10">Visibility</h4>
  <nz-select nzShowSearch class="w-100-pc" nzPlaceHolder="Select post visibility" [(ngModel)]="noteDO.visibilityCd">
    <nz-option *ngFor="let item of (lookup$['docVisibilityCd'] | async) as docVisibilityCd; trackBy:item?.lookupKey"
      [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
    </nz-option>
  </nz-select>

  <div class="m-t-20">
    <h4 class="d-i-b m-r-10">Posting as</h4>
    <nz-avatar nzSize="small" nzIcon="user"> {{getUserDetails()}} </nz-avatar>&nbsp;
    <!-- Here must be name of logged in user -->
  </div>

  <button nz-button nzType="primary" class="m-t-20" (click)="saveNotes()" [nzLoading]="_noteSaveInProgress">Add Note</button>
  <nz-divider nzText="Notes" class="m-t-20"></nz-divider>

  <div>
    <div class="list-note">
      <div class="list-note-content" *ngFor="let item of noteList">
        <h4 class="list-note-title"><i class="anticon anticon-message"></i> {{item.createdUser}}</h4>
        <div class="list-note-description">
          {{item.description}}
          <br>
          Visibility : {{(item.visibilityCd | technicalTranslate) || ''}}
          <br>
         Date : {{ getDateString(item.createdDt)}}
         <br>
         <span *ngIf="item?.noteTypeCd != null"><b>{{item.noteTypeCd}}</b></span>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="mode=='mini' ">
  <nz-divider nzText="Previous remarks" class="m-t-20"></nz-divider>
  <div *ngFor="let item of noteList">
    <div *ngIf="item.entityStageCd == 'claimAdjudication' ">
      <h4 class="list-note-title"><i class="anticon anticon-message"></i> {{item.createdUser}}</h4>
      <div class="list-note-description">
        <pre style="width: 100%; font-family: Arial;white-space: pre-wrap;">{{item.description}}</pre>
      </div>
    </div>
  </div>
</div>
